import React from 'react';
import PropTypes from 'prop-types';
import lockTypes from 'enums/lockTypes';

import ParakeyStorageSiteLockConfigurationEditor from './ParakeyStorageSiteLockConfigurationEditor';
import IloqStorageSiteLockConfigurationEditor from './IloqStorageSiteLockConfigurationEditor';


const StorageSiteLockConfigurationEditor = ({ fieldNamePrefix, lockType }) => {
    const parameters = {
        fieldNamePrefix: `${fieldNamePrefix}.${lockType}`
    };
    switch(lockType) {
        case lockTypes.parakey.key:
            return <ParakeyStorageSiteLockConfigurationEditor {...parameters} />;
        case lockTypes.iloq.key:
            return <IloqStorageSiteLockConfigurationEditor {...parameters}/>;
        default:
            return null;
    }
};

StorageSiteLockConfigurationEditor.propTypes = {
    fieldNamePrefix: PropTypes.string.isRequired,
    lockType: PropTypes.string
};

export default StorageSiteLockConfigurationEditor;
